module.exports = __webpack_public_path__ + "img/md-git-branch.b88659c3.svg";